import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import ProductCards from '../products/ProductCards'
import ShoppingCart from '../cart/ShoppingCart'
import GridShowcase from './GridShowcase'

const Showcase = (
  { settings,
    cart,
    showcaseNum,
    productShown,
    scene,
    isCartOpened,
    showProduct,
    handleSlideChange,
    previousScene,
    nextScene,
    switchCart,
    closeProduct,
    openSettings,
    closeSettings,
    isVisible,
    getProductInfo,
    prodMode }) => {
  const showcases = []
  for (const s of settings.showcases) {
    if (!s.disabled) showcases.push(s)
  }
  return (
    <CSSTransitionGroup
      transitionName='in_swiper'
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={100}
    >
      {isVisible && [
        <GridShowcase
          showcases={showcases}
          showProduct={showProduct}
          onSlideChange={handleSlideChange}
          slide={showcaseNum}
          cart={cart}
          switchCart={switchCart}
          scrollableItems={settings.scrollableItems}
          key='swiper'
          gridColumns={settings.appSettings.columns}
          getProductInfo={getProductInfo}
        />,
        <ShoppingCart
          cart={cart}
          onClose={switchCart}
          isVisible={isCartOpened}
          key='cart'
          prodMode={prodMode}
        />,
        <ProductCards
          showcases={showcases}
          scene={scene}
          productShown={productShown}
          closeProduct={closeProduct}
          openSettings={openSettings}
          closeSettings={closeSettings}
          getProductInfo={getProductInfo}
          key='products'
          prodMode={prodMode}
        />
      ]}
    </CSSTransitionGroup>
  )
}

Showcase.propTypes = {
  settings: PropTypes.object,
  cart: PropTypes.object,
  showcaseNum: PropTypes.number,
  productShown: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scene: PropTypes.string,
  isCartOpened: PropTypes.bool,
  showProduct: PropTypes.func,
  handleSlideChange: PropTypes.func,
  previousScene: PropTypes.func,
  nextScene: PropTypes.func,
  switchCart: PropTypes.func,
  closeProduct: PropTypes.func,
  openSettings: PropTypes.func,
  closeSettings: PropTypes.func,
  isVisible: PropTypes.bool,
  getProductInfo: PropTypes.func,
  prodMode: PropTypes.bool
}

export default Showcase



// WEBPACK FOOTER //
// ./src/templates/insta/components/showcase/Showcase.js